var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidentCodeSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 28.1517 1.62078 31.2726 2.82689 34.1844C4.033 37.0962 5.80083 39.742 8.02944 41.9706C10.258 44.1992 12.9038 45.967 15.8156 47.1731C18.7274 48.3792 21.8483 49 25 49C28.1517 49 31.2726 48.3792 34.1844 47.1731C37.0962 45.967 39.742 44.1992 41.9706 41.9706C44.1992 39.742 45.967 37.0962 47.1731 34.1844C48.3792 31.2726 49 28.1517 49 25C49 21.8483 48.3792 18.7274 47.1731 15.8156C45.967 12.9038 44.1992 10.258 41.9706 8.02944C39.742 5.80083 37.0962 4.033 34.1844 2.82689C31.2726 1.62078 28.1517 1 25 1C21.8483 1 18.7274 1.62078 15.8156 2.82689C12.9038 4.033 10.258 5.80083 8.02944 8.02944C5.80083 10.258 4.033 12.9038 2.82689 15.8156C1.62078 18.7274 1 21.8483 1 25Z",
    fill: "#16C270",
    stroke: "#16C270",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H16.308",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.7441H14.872",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6454 20.5862L19.7838 29.2022C19.7439 29.6014 19.788 30.0046 19.9135 30.3858C20.0389 30.7669 20.2428 31.1175 20.512 31.415C20.7813 31.7126 21.1099 31.9503 21.4766 32.1131C21.8434 32.2758 22.2402 32.3599 22.6414 32.3599H34.1006C34.8129 32.3599 35.4996 32.0953 36.0277 31.6174C36.5558 31.1395 36.8874 30.4824 36.9583 29.7737L37.8199 21.1578C37.8598 20.7585 37.8156 20.3553 37.6902 19.9742C37.5648 19.593 37.3608 19.2424 37.0916 18.9449C36.8224 18.6474 36.4938 18.4096 36.127 18.2469C35.7603 18.0841 35.3635 18 34.9622 18H23.503C22.7908 18 22.104 18.2647 21.576 18.7426C21.0479 19.2205 20.7162 19.8776 20.6454 20.5862Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7637 18.7168L26.0458 23.4269C26.4263 23.8455 26.8856 24.1851 27.3974 24.4263C27.9092 24.6674 28.4635 24.8054 29.0286 24.8324C29.5937 24.8593 30.1586 24.7747 30.691 24.5833C31.2234 24.3919 31.7129 24.0975 32.1316 23.7169L36.8416 19.4348",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentCodeSent);
export default __webpack_public_path__ + "static/media/resident-code-sent.82d07d653657a0dfebc6701e22bdbf96.svg";
export { ForwardRef as ReactComponent };